const BASE_URL = process.env.REACT_APP_MAP_BASE_DEV;
const BASE_URL_NON_DEV = process.env.REACT_APP_MAP_BASE;
const BASE_URL_BACKEND = process.env.REACT_APP_MAP_BACKEND;
const BASE_URL_BACKEND_NON_DEV = process.env.REACT_APP_MAP_BACKEND_NON_DEV;
const BASE_URL_INSIGHT = process.env.REACT_APP_INSIGHT;

export const client_id = process.env.REACT_APP_CLIENT_ID_MAP;
export const secret_key = process.env.REACT_APP_SECRET_KEY_MAP;

export const API = {
  register: process.env.REACT_APP_API_ACCOUNTV2 + 'v1/api/mobile/register',
  user_exist: BASE_URL + '/users/auth/exist',
  login: process.env.REACT_APP_API_AUTH + 'v1/auth/login',
  forget_password: `${process.env.REACT_APP_API_ACCOUNTV2}/v1/auth/forgot`,
  reset_password: BASE_URL + '/users/reset-password',
  activation: process.env.REACT_APP_API_ACCOUNTV2 + '/v1/auth/emailverifikasi',

  service: {
    area_city: BASE_URL_NON_DEV + '/services/price/area-city/get',
    time: BASE_URL_NON_DEV + '/services/price/time/get',
    type_of_year: BASE_URL_NON_DEV + '/services/price/type-of-year/get',
    unit_condition: BASE_URL_NON_DEV + '/services/price/unit-condition/get',
    variant: BASE_URL_BACKEND_NON_DEV + '/services/map/stock/get/variant',
  },
};

export const API_CHECK_PRICE = {
  check_price: BASE_URL_BACKEND_NON_DEV + '/services/map/check-price',
  probability: BASE_URL + '/services/probability',
};

export const API_FILTER = {
  filter: BASE_URL_BACKEND + '/services/stock/master-data-',
};

export const API_MARKETPRICE_DB = {
  get: BASE_URL + '/services/markets/get',
  detail: BASE_URL + '/services/markets/detail/get',
};

export const API_INSIGHT = {
  baseunit: BASE_URL_INSIGHT + '/api/overviewibid/Ibidpricebasedunitconditions',

  chart_profile: BASE_URL + '/services/profiles/get',
  insight: BASE_URL + '/services/insight/get',
  update_profile: BASE_URL + '/services/profiles/update',
};

export const API_TOKEN = {
  token: BASE_URL + '/refresh_token',
};

export const API_REQUEST_PREMIUM = {
  premium: (userID) => process.env.REACT_APP_API_ACCOUNTV2 + `/api/v2/map/users/request-premium/${userID}`,
};

export const API_REFRESH_TOKEN = {
  token: BASE_URL + '/refresh_token',
};
